import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function ShinjiTakahashi() {
  const dateTexts = ['xxxx年'];
  const title = '高橋シンジがコアトルに魔法をかけられる';
  const description = (
    <>
      <a href='/shinji-takahashi-and-the-mark-of-the-coatl'>
        {'高橋シンジ'}
      </a>
      {'が魔法のガーディアン「コアトル」に魔法をかけられ、'}
      <a href='/hightower-co'>
        {'ハイタワー・コーポレーション'}
      </a>
      {'にその身を狙われる。'}
      {'シンジは魔法を解くために、現代のS.E.A.のメンバーたちと協力する。'}
    </>
  );
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2022/01/FEpSz9UXMAUF2Tm-1.jpg';
  const quoteDomain = 'twitter.com - @DisneyD23';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default ShinjiTakahashi;
